import type { ShipmentInfo } from 'api';
import { CarrierAutocomplete, DateTimeField, PortAutocomplete, TextField } from 'form';
import { useTranslation } from 'i18n';
import { SectionContainer } from 'ui';

interface Props {
  defaultValues?: ShipmentInfo;
}

export const ShipmentUpdateFieldsSection = ({ defaultValues }: Props) => {
  const { t } = useTranslation('orders');

  return (
    <>
      <SectionContainer title={t('shipmentFields.sections.general')}>
        <TextField label={t('shipmentFields.labels.billOfLadingNumber')} name="bill_of_lading_number" />
        <CarrierAutocomplete name="carrier_1_id" label={t('shipmentFields.labels.carrier1')} />
        <CarrierAutocomplete name="carrier_2_id" label={t('shipmentFields.labels.carrier2')} />
        <CarrierAutocomplete name="carrier_3_id" label={t('shipmentFields.labels.carrier3')} />
        <TextField label={t('shipmentFields.labels.carrierBookingReference')} name="carrier_booking_reference" />
        <TextField label={t('shipmentFields.labels.dhlTrackingNumber')} name="dhl_tracking_number" />
        <DateTimeField label={t('shipmentFields.labels.docsCutOffTime')} name="docs_cut_off_time" />
        <DateTimeField
          label={t('shipmentFields.labels.estimatedVesselDepartureTime')}
          name="estimated_vessel_departure_time"
        />
        <TextField label={t('shipmentFields.labels.freightForwarderReference')} name="freight_forwarder_reference" />
        <TextField label={t('shipmentFields.labels.manualInvoiceNumber')} name="manual_invoice_number" />
        <PortAutocomplete
          name="port_of_loading_id"
          label={t('shipmentFields.labels.selectPortOfLoading')}
          defaultValue={defaultValues?.port_of_loading_id ?? undefined}
        />
        <TextField label={t('shipmentFields.labels.royalMailTrackingNumber')} name="royal_mail_tracking_number" />
        <DateTimeField label={t('shipmentFields.labels.scheduledDeliveryTime')} name="scheduled_delivery_time" />
        <TextField label={t('shipmentFields.labels.vesselNameOverride')} name="vessel_name_override" />
        <DateTimeField label={t('shipmentFields.labels.vgmCutOffTime')} name="vgm_cut_off_time" />
        <TextField label={t('shipmentFields.labels.voyageNumberOverride')} name="voyage_number_override" />
        <TextField
          label={t('shipmentFields.labels.freeTimeAvailableDays')}
          name="free_time_available"
          type="number"
          slotProps={{ htmlInput: { min: 0 } }}
          helperText={t('shipmentFields.helperText.freeTimeAvailable')}
        />
        <TextField
          sx={{ gridColumn: 'span 3' }}
          label={t('shipmentFields.labels.additionalInvoiceDescription')}
          name="additional_invoice_description"
          multiline
          rows={10}
        />
      </SectionContainer>
      <SectionContainer title={t('shipmentFields.sections.tracking')}>
        <DateTimeField
          label={t('shipmentFields.labels.scheduledPortDepartureTime')}
          name="scheduled_port_departure_time"
        />
        <DateTimeField
          label={t('shipmentFields.labels.manualEstimatedPortDepartureTime')}
          name="manual_estimated_port_departure_time"
        />
        <DateTimeField
          label={t('shipmentFields.labels.manualActualPortDepartureTime')}
          name="manual_actual_port_departure_time"
        />
        <DateTimeField label={t('shipmentFields.labels.scheduledPortArrivalTime')} name="scheduled_port_arrival_time" />
        <DateTimeField
          label={t('shipmentFields.labels.manualEstimatedPortArrivalTime')}
          name="manual_estimated_port_arrival_time"
        />
        <DateTimeField
          label={t('shipmentFields.labels.manualActualPortArrivalTime')}
          name="manual_actual_port_arrival_time"
        />
      </SectionContainer>
    </>
  );
};
